<template>
  <div style="height: 100%;width: 100%">
      <div class="primary" style="margin-bottom: 10px" v-if="parentData.wujian_id" >{{parentData.wujian_id+"("+parentData.wujian_short_name+")"}}</div>
      <div style="display: flex;height: 100%">
        <div style="display:flex;flex-direction:column;align-items:center;margin-top: 5px;justify-content: space-evenly;height: 100%;width: 25%" v-for="item in formData.wuJianData" :key="item.wuJianId">
          <div class="station1" :style="{backgroundColor:item.color}">{{ item.stage_name }}</div>
          <div class="station1_out">
            <div class="station_1_1" :style="{backgroundColor:item.color}">负责人</div>
            <div class="station_1_2" :style="{border:item.border,color:item.color}">{{ item.commander }}</div>
          </div>
          <div class="station1_out">
            <div class="station_1_1" :style="{backgroundColor:item.color}">计划产量</div>
            <div class="station_1_2" :style="{border:item.border,color:item.color}">{{ item.plan_num }}</div>
          </div>
          <div class="station1_out">
            <div class="station_1_1" :style="{backgroundColor:item.color}">实际产量</div>
            <div class="station_1_2" :style="{border:item.border,color:item.color}">{{ item.reality }}</div>
          </div>
          <div class="station_1_3" :style="{backgroundColor:item.color}">现&nbsp;&nbsp;&nbsp;时&nbsp;&nbsp;&nbsp;点&nbsp;&nbsp;&nbsp;产&nbsp;&nbsp;&nbsp;量</div>
          <div style="width: 310px;height: 310px;margin-top: -40px" :id="item.stage_name">{{getOption(item)}}</div>
        </div>
      </div>
    </div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "AmLineStatesPage4",
  props: {
    parentData:Object
  },
  data() {
    return {
      formData:{
        wuJianData:[],
        wujianName:""
      },
      option :{
        xAxis: {
          type: 'category',
          data: ['计划', '实际'],
          nameTextStyle: {
            fontSize: 18
          },axisLabel: {
            fontSize: 18
          }
        },
        yAxis: {
          type: 'value',
          nameTextStyle: {
            fontSize: 18
          },axisLabel: {
            fontSize: 18
          }
        },
        series: [
          {
            data: [],
            type: 'bar',
            label: {
              show: true,
              position: 'inside',
              fontSize: '25'
            },
          }
        ]
      }
    }
  },computed: {

  }
  ,methods:{
    renderEcharts(id,option){
      if (document.getElementById(id)) {
        echarts.init(document.getElementById(id)).dispose();
        let chart = echarts.init(document.getElementById(id));
        chart.setOption(option)}
    },
    getOption(item) {
      setTimeout(()=>{
        if (item){
          this.option.series[0].data = item.series
          this.renderEcharts(item.stage_name,this.option)
        }
      },500)
    },
    //获取页面的加载的数据
    getAmLineStatesStation(){
      this.$axios.post('am/lineStates/getAmLineStatesStation', this.parentData).then(response => {
        let res = response.data
        this.formData.wuJianData = res.data;
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
  },created() {
    this.getAmLineStatesStation();
  },
}
</script>

<style scoped>
.station1 {
  width:84%;
  height:60px;
  line-height: 60px;
  font-weight: bold;
  font-size: 50px;
  text-align: center;
  border-radius: 8px;
  color: white;
}

.station1_out{
  display: flex;
  width: 83%;
  justify-content: space-between;
}

.station_1_1 {
  width: 50%;
  height: 45px;
  font-size: 30px;
  font-weight: bold;
  line-height: 45px;
  text-align: center;
  border-radius: 8px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}

.station_1_3 {
  width: 84%;
  height: 50px;
  font-size: 30px;
  font-weight: bold;
  line-height: 50px;
  text-align: center;
  border-radius: 8px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}

.station_1_2 {
  width: 50%;
  height:45px;
  line-height: 45px;
  font-weight: bold;
  font-size: 24px;
  text-align: center;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.primary {
  width: 100%;
  height:10%;
  font-weight: bold;
  font-size: 60px;
  text-align: center;
  color: black;
}
</style>